<template>
    <b-modal id="approval_delete" ref="approval_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.approval.data.attributes.code + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('approval_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteApproval">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "ApprovalDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'approval'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteApproval() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteApproval', this.approval)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-approval');

                            this.$notify('error filled', 'Success!', 'Deleted the approval!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('approval_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
